import { type Repub } from '@cx-modules/constants';

export const SUPPORTED_REPUB_NAMES = ['WS', 'US', 'OC', 'GZ'] as const;

export type SupportedRepubName = (typeof SUPPORTED_REPUB_NAMES)[number];
export type SupportedRepubCountry = 'it' | 'uk' | 'us';

export const REPUB_COUNTRY: Record<SupportedRepubName, SupportedRepubCountry> = {
  GZ: 'it',
  OC: 'uk',
  US: 'us',
  WS: 'uk',
};

export const REPUB_COUNTRY_BY_REPUB: Partial<Record<Repub, 'uk' | 'us' | 'it'>> = {
  OC: 'uk',
  US: 'us',
  WS: 'uk',
  GZ: 'it',
};
